export var CoinKey;
(function (CoinKey) {
    CoinKey["ETH"] = "ETH";
    CoinKey["MATIC"] = "MATIC";
    CoinKey["POL"] = "POL";
    CoinKey["BNB"] = "BNB";
    CoinKey["DAI"] = "DAI";
    CoinKey["FTM"] = "FTM";
    CoinKey["AVAX"] = "AVAX";
    CoinKey["ONE"] = "ONE";
    CoinKey["FSN"] = "FSN";
    CoinKey["MOVR"] = "MOVR";
    CoinKey["CELO"] = "CELO";
    CoinKey["FUSE"] = "FUSE";
    CoinKey["TLOS"] = "TLOS";
    CoinKey["CRO"] = "CRO";
    CoinKey["RBTC"] = "RBTC";
    CoinKey["VLX"] = "VLX";
    CoinKey["GLMR"] = "GLMR";
    CoinKey["METIS"] = "METIS";
    CoinKey["EVM"] = "EVM";
    CoinKey["MNT"] = "MNT";
    CoinKey["SEI"] = "SEI";
    CoinKey["G"] = "G";
    CoinKey["IMX"] = "IMX";
    CoinKey["KAIA"] = "KAIA";
    CoinKey["OKB"] = "OKB";
    CoinKey["WLD"] = "WLD";
    CoinKey["LSK"] = "LSK";
    CoinKey["BERA"] = "BERA";
    CoinKey["S"] = "S";
    CoinKey["APE"] = "APE";
    CoinKey["GHO"] = "GHO";
    CoinKey["WGHO"] = "WGHO";
    CoinKey["XTZ"] = "XTZ";
    CoinKey["HYPE"] = "HYPE";
    CoinKey["XDC"] = "XDC";
    CoinKey["VIC"] = "VIC";
    CoinKey["FLR"] = "FLR";
    CoinKey["VAN"] = "VAN";
    CoinKey["RON"] = "RON";
    CoinKey["PLU"] = "PLUME";
    CoinKey["NIBI"] = "NIBI";
    CoinKey["SOPH"] = "SOPH";
    CoinKey["XPL"] = "XPL";
    CoinKey["FLOW"] = "FLOW";
    CoinKey["MON"] = "MON";
    // Solana
    CoinKey["SOL"] = "SOL";
    CoinKey["WSOL"] = "wSOL";
    // MVM
    CoinKey["SUI"] = "SUI";
    // UTXO
    CoinKey["BTC"] = "BTC";
    CoinKey["BCH"] = "BCH";
    CoinKey["LTC"] = "LTC";
    CoinKey["DOGE"] = "DOGE";
    // Tron
    CoinKey["TRX"] = "TRX";
    CoinKey["WTRX"] = "WTRX";
    // Tether Gold
    CoinKey["XAUt"] = "XAUt";
    // Hemi chain token
    CoinKey["HEMI"] = "HEMI";
    // Stable coins
    CoinKey["USDT"] = "USDT";
    CoinKey["USDC"] = "USDC";
    CoinKey["BUSD"] = "BUSD";
    CoinKey["USDCe"] = "USDCe";
    CoinKey["USDCn"] = "USDCn";
    CoinKey["USDe"] = "USDe";
    CoinKey["USDB"] = "USDB";
    CoinKey["FRAX"] = "FRAX";
    CoinKey["AXLUSDC"] = "axlUSDC";
    CoinKey["FDUSD"] = "FDUSD";
    CoinKey["HONEY"] = "HONEY";
    CoinKey["BYUSD"] = "BYUSD";
    CoinKey["APEUSD"] = "APEUSD";
    CoinKey["FEUSD"] = "FEUSD";
    CoinKey["USDT0"] = "USDT0";
    CoinKey["USDF"] = "USDF";
    // Other tokens
    CoinKey["WBTC"] = "WBTC";
    CoinKey["WETH"] = "WETH";
    CoinKey["SUSHI"] = "SUSHI";
    CoinKey["DODO"] = "DODO";
    CoinKey["MCB"] = "MCB";
    CoinKey["CELR"] = "CELR";
    CoinKey["IF"] = "IF";
    CoinKey["RUNE"] = "RUNE";
    CoinKey["WMNT"] = "WMNT";
    CoinKey["frxETH"] = "frxETH";
    CoinKey["wfrxETH"] = "wfrxETH";
    CoinKey["WSEI"] = "WSEI";
    CoinKey["WG"] = "WG";
    CoinKey["WIMX"] = "WIMX";
    CoinKey["WPOL"] = "WPOL";
    CoinKey["WKAIA"] = "WKAIA";
    CoinKey["WOKB"] = "WOKB";
    CoinKey["WBNB"] = "WBNB";
    CoinKey["WCRO"] = "WCRO";
    CoinKey["WBERA"] = "WBERA";
    CoinKey["wS"] = "wS";
    CoinKey["WAPE"] = "WAPE";
    CoinKey["WXTZ"] = "WXTZ";
    CoinKey["WHYPE"] = "WHYPE";
    CoinKey["WXDC"] = "WXDC";
    CoinKey["WVIC"] = "WVIC";
    CoinKey["WFLR"] = "WFLR";
    CoinKey["WVAN"] = "WVAN";
    CoinKey["WRON"] = "WRON";
    CoinKey["WPLU"] = "WPLUME";
    CoinKey["WNIBI"] = "WNIBI";
    CoinKey["WSOPH"] = "WSOPH";
    CoinKey["WFRAX"] = "WFRAX";
    CoinKey["WXPL"] = "WXPL";
    CoinKey["WFLOW"] = "WFLOW";
    CoinKey["WMON"] = "WMON";
})(CoinKey || (CoinKey = {}));
//# sourceMappingURL=base.js.map